import script from "./ExhibitBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ExhibitBody.vue?vue&type=script&setup=true&lang=js"

import "./ExhibitBody.vue?vue&type=style&index=0&id=10c3b9c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c3b9c4"]])

export default __exports__